import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { cn } from '../lib/utils';
import { phases, systemIncludes, tools } from '../data/system';
export function SystemBlueprint() {
  return <section aria-label="Il metodo completo in 6 fasi" className="bg-navy text-white" data-id="element-248" data-mp="29sbrptbvo7vl">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "20px",
      paddingBottom: "28px"
    }} data-id="element-249" data-mp="24ts1hgq949xf">
        <div className="mx-auto max-w-3xl text-center" data-id="element-250" data-mp="1zxa1sv9s31ry">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-aqua" data-id="element-251" data-mp="1vtltgadbo25n">
            Il Sistema Triathlon Full Distance™ · Il sistema completo in 6 fasi
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] sm:text-6xl" data-id="element-252" data-mp="1lvxneoa9n886">
            Un unico sistema per organizzare il percorso dalla preparazione al traguardo.
          </h2>
          <p className="mt-5 text-lg font-semibold text-white/70" data-id="element-253" data-mp="3ga8df02lk8fj">Il metodo completo in 6 fasi</p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-254" data-mp="yw25wvigaz4h">
          {phases.map((p, idx) => {
          const Icon = p.icon;
          return <motion.article key={p.n} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: idx % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-obsidian/60 p-6" data-id="element-255" data-mp="12zqbj8nivkn3" data-mpi={idx}>
                <div className="flex items-center justify-between" data-id="element-256" data-mp="1mo8vnbto87ux">
                  <span className="font-display text-5xl font-extrabold leading-none text-electric" data-id="element-257" data-mp="17wgv45yjcyd9">{p.n}</span>
                  <span className="rounded-md border border-aqua/25 bg-aqua/10 px-2 py-1 text-[11px] font-semibold uppercase tracking-wider text-aqua" data-id="element-258" data-mp="1cus3sdd3h2tw">
                    {p.weeks}
                  </span>
                </div>
                <div className="mt-4 flex gap-1" aria-hidden="true" data-id="element-259" data-mp="25egxzrpjqua2">
                  {phases.map((_, k) => <span key={k} className={cn('h-1 flex-1 rounded-full', k < idx ? 'bg-perf' : k === idx ? 'bg-electric' : 'bg-white/10')} data-id="element-260" data-mp="2f6joty53pt02" data-mpi={k} />)}
                </div>
                <h3 className="mt-5 font-display text-2xl font-extrabold uppercase leading-tight" data-id="element-261" data-mp="2595ac42qneae">{p.title}</h3>
                <p className="mt-2 font-semibold leading-snug text-white" data-id="element-262" data-mp="218bm19ldvxgz">{p.lead}</p>
                <p className="mt-2 text-sm leading-relaxed text-white/65" data-id="element-263" data-mp="1wajvok0e0jew">{p.desc}</p>
                <p className="mt-auto flex items-center gap-2 pt-5 text-xs font-semibold uppercase tracking-wider text-white/45" data-id="element-264" data-mp="1ri0kftp6a0d9">
                  <Icon className="h-4 w-4 text-aqua" aria-hidden="true" data-id="element-265" data-mp="1mk8i05qwivut" />
                  Fase {p.n} di 06
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-14" data-id="element-266" data-mp="1dhz7vgzjp4hy">
          <p className="text-center font-display text-2xl font-extrabold uppercase sm:text-3xl" data-id="element-267" data-mp="1dld8ajonf3mr">
            In più, 4 strumenti pratici per completare il sistema
          </p>
          <p className="mt-2 text-center text-sm text-white/60" data-id="element-268" data-mp="3k715w3exnrw6">
            Tutto collegato in un unico percorso di preparazione al triathlon di lunga distanza.
          </p>
          <ol className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 lg:grid-cols-4" data-id="element-269" data-mp="3t9ahkwlxtrb5">
            {tools.map(({
            verb,
            name,
            icon: Icon
          }) => <li key={verb} className="flex flex-col gap-3 bg-navy p-5" data-id="element-270" data-mp="31icq1vvb4cr9">
                <Icon className="h-5 w-5 text-electric" aria-hidden="true" data-id="element-271" data-mp="35i52wkrqh52f" />
                <p className="font-display text-2xl font-extrabold uppercase leading-none sm:text-3xl" data-id="element-272" data-mp="3ahq30yin3jgq">{verb}</p>
                <p className="text-sm leading-snug text-white/60" data-id="element-273" data-mp="3f86hmly75b4o">{name}</p>
              </li>)}
          </ol>
        </div>

        <div className="mt-14 rounded-2xl border border-white/10 bg-obsidian/50 p-6 sm:p-8" data-id="element-274" data-mp="2hs0zadejp5bf">
          <p className="font-display text-2xl font-extrabold uppercase" data-id="element-275" data-mp="2mrdjsrhy20au">
            Ogni parte del sistema affronta aspetti importanti della preparazione
          </p>
          <ul className="mt-6 grid gap-x-6 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-276" data-mp="oabtjwg07oui">
            {systemIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-white/80" data-id="element-277" data-mp="121i0gdlm4orf">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-278" data-mp="xb9w0aasnoaz" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}